import { PARTITION } from './constants';
import type { ReduxState } from './reducer';

const selectPartition = (state: any): ReduxState => state[PARTITION];

const selectCheckOut = (state: any) => selectPartition(state) && selectPartition(state).checkOut;
const selectCheckOutId = (state: any) => selectPartition(state) && selectPartition(state).qsParamsCheckOutId;
const selectCheckOutMobileNumber = (state: any) => selectCheckOut(state) && selectCheckOut(state).mobileNumber;
const selectMerchantRedirectUrl = (state: any) => selectCheckOut(state) && selectCheckOut(state).redirectUrl;

export default {
  selectPartition,
  selectCheckOut,
  selectCheckOutId,
  selectCheckOutMobileNumber,
  selectMerchantRedirectUrl,
};
